import colors from '@general/colors';
import React from 'react';
import { Link } from "react-router-dom";
import { components } from 'react-select';

export default function SavedSearchCriteriaMenuList({ children, ...props }) {
    return (
        <components.MenuList {...props}>
            {children}
            <div
                style={{
                    padding: '8px 12px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    color: '#b4b4b4',
                }}
            >
                <span>Create a new criteria in Connections</span>
                <Link style={{ color: colors.azure, fontSize: "0.875rem" }} to="/my-icsc/connections/matches/new">
                    Create New
                </Link>
            </div>
        </components.MenuList>
    );
};
